/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeneralSettingsModel } from '../../models/general-settings-model';

export interface GeneralSettings$Params {
}

export function GeneralSettings(http: HttpClient, rootUrl: string, params?: GeneralSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralSettingsModel>> {
  const rb = new RequestBuilder(rootUrl, GeneralSettings.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GeneralSettingsModel>;
    })
  );
}

GeneralSettings.PATH = '/api/Account/GeneralSettings';
